// Ekran 12 — Çıkış. Kabuksuz; oturum özeti gerçek veriden.
// Markup ref_files/btys-erp-12-cikis.html'den alındı.

import { useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import { useOturum } from '../../lib/oturum'
import { trTarihSaat } from '../../lib/trFormat'
import '../../styles/cikis.css'

type Ozet = {
  ad: string
  tesis: string
  baslangic: string
}

export default function CikisSayfasi() {
  const { durum, cikisYap } = useOturum()
  // Çıkış tamamlanınca durum sıfırlanıyor; özeti göstermeye devam edebilmek için
  // kapanmadan önceki bilgiyi tutuyoruz.
  const [ozet, setOzet] = useState<Ozet | null>(null)
  const calisti = useRef(false)

  useEffect(() => {
    if (calisti.current) return
    calisti.current = true

    if (durum) {
      setOzet({
        ad: durum.kullanici.ad,
        // Süper adminin tesisi yok — özet satırı rolü yazıyor.
        tesis: durum.tesis?.ad ?? 'Sistem yönetimi',
        baslangic: new Date().toISOString(),
      })
    }
    void cikisYap()
  }, [durum, cikisYap])

  return (
    <div className="sf-cikis">
      <div className="card">
        <div className="ok">
          <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M20 6 9 17l-5-5" />
          </svg>
        </div>
        <h1>Oturumunuz kapatıldı</h1>

        <div className="sum">
          <div className="r">
            <span>Kullanıcı</span>
            <b>{ozet?.ad ?? '—'}</b>
          </div>
          <div className="r">
            <span>Tesis</span>
            <b>{ozet?.tesis ?? '—'}</b>
          </div>
          <div className="r">
            <span>Kapanış</span>
            <b>{trTarihSaat(ozet?.baslangic)}</b>
          </div>
        </div>

        <div className="note">
          Kaydedilmemiş taslaklarınız korunur. Onaylı kayıtlar değişmez (K15).
        </div>

        <Link className="btn btn-pri" to="/giris">
          Tekrar giriş yap
        </Link>
      </div>
    </div>
  )
}
